import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import Alert from 'react-bootstrap/Alert';
import * as globalSelectors from 'store/global/selectors';
import LoadingSpinner from 'components/LoadingSpinner';
import { setIsBrandFilterable } from 'store/global/actions';
import {
  GetBrandsFilteringStatusQuery as BrandsFilteringStatusResult,
  GetBrandsFilteringStatusQueryVariables as BrandsFilteringStatusVars,
  GetBrandsFilteringStatusDocument as brandsFilteringStatusQuery,
} from 'generated/signals-graphql';

interface Props {
  children: React.ReactElement;
  currentBrand: string;
}

const BrandFilteringStatusLoader: React.FC<Props> = ({ children, currentBrand }) => {
  const dispatch = useDispatch();
  const clientId: string = useSelector(globalSelectors.clientIdSelector);
  const [statusLoaded, setStatusLoaded] = useState(false);

  const { loading, error } = useQuery<BrandsFilteringStatusResult, BrandsFilteringStatusVars>(
    brandsFilteringStatusQuery,
    {
      variables: {
        client: clientId,
        brandId: currentBrand,
      },
      fetchPolicy: 'cache-first',
      onCompleted: (data) => {
        if (data) {
          dispatch(setIsBrandFilterable(data.getBrandsFilteringStatus.status !== 'NOT_FILTERABLE'));
          setStatusLoaded(true);
        }
      },
    }
  );

  if (error) {
    return (
      <Alert variant="danger">
        An error occurred while trying to get feed data for the current user.
      </Alert>
    );
  }

  if (loading || !statusLoaded) {
    return <LoadingSpinner centered={true} />;
  }

  return children;
};

export default BrandFilteringStatusLoader;
